<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('wdtd.title')}}</div>
            <!-- <div class="invite" @click="invite">{{this.$t('wdtd.yqhy')}}</div>                                           -->
        </div>
        <div class="cont-box">
            <div class="team-box">
                <div class="num">{{own_group_num}} <span class="small">{{this.$t('wdtd.ren')}}</span></div>
                <div class="tips">{{this.$t('wdtd.wdtdzrs')}}</div>
                <div class="copy-box">
                    <div class="text">{{code}}</div>
                    <img class="icon" src="@/assets/copy.png" @click="copy($event)" alt="">
                </div>
            </div>
            <div class="title">{{this.$t('wdyj.wdyd')}}</div>
            <div class="list-bg">
                <ul class="ul-box">
                    <li class="list" v-for="(item,index) in listData" :key="index" @click="jump(item.name)">
                        <div class="list-item">
                            <div class="text">{{$t('wdtd.uid')}}<span class="cont">{{item.id}}</span></div>
                            <div class="text">{{$t('wdtd.zh')}}<span class="cont">{{item.name}}</span></div>
                        </div>
                        <div class="list-item list-item-foot">
                            <div class="text">{{$t('wdtd.zcsj')}}<span class="cont">{{item.add_time}}</span></div>
                        </div>
                        <!-- <img class="arrow" v-show="item.own_group_num > 0" src="@/assets/arrow-white.png" alt=""> -->
                    </li>
                </ul>
                <no-data v-show="hasData"></no-data>
            </div>
            <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        </div>
    </div>

</template>

<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that;
export default {
    name: 'wdtd',
    data () {
        return {
            uid: '',
            token: '',
            code: '',
            own_group_num: 0,
            listData: [],
            listData2: [],
            listData3: [],
            wdtdUid: [],
            hasData: false,
            isGoTOP: false,
            scrollbarObj: {
                fade: true
            },
             // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
            pullDownRefreshObj: {
                threshold: 90,
                stop: 40,
                txt: this.$t('tips.sxcg')
            },
            // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
            pullUpLoadObj: {
                threshold: 0,
                txt: {
                    more: this.$t('tips.jzgd'),
                    noMore: this.$t('tips.mygdsjl')
                }
            },
            startY: 0, // 纵轴方向初始化位置
            scrollToY: 0,
            scrollToTime: 500,
            page: 1,
            limit: 10,
            timestamp: 0
        }
    },
    beforeCreate() {
        that = this;
    },
    created(){
        this.code = localStorage.getItem('invite_code');
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token = localStorage.getItem('token');
        this.timestamp = localStorage.getItem('timestamp') || 0;
    },
    mounted() {
      this.getMyEarnings();
      this.getMyteam();
    },
    methods: {
      getMyteam(){//团队业绩
        this.$ajax.post('/web/myteam').then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.own_group_num = parseInt(resData.team_1) + parseInt(resData.team_2) + parseInt(resData.team_3);
            this.listData = this.listData.concat(resData.team_list_1);
            this.listData2 = resData.team_list_2;
            this.listData3 = resData.team_list_3;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getMyEarnings(){//地址
        this.$ajax.post('/web/getMyEarningsAndPromotion').then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.code = resData.invitation_code;
            localStorage.setItem('invite_code',resData.invitation_code)
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      listenScroll(e) {  //监听滚动
          let ele = e.srcElement ? e.srcElement : e.target;
          if(ele.scrollTop > 200){
              this.isGoTOP = true
          }else{
              this.isGoTOP = false
          }
          if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
              if(this.curDataLength > 0){
                  this.page ++;
                  this.getMyteam();
              }
          }
      },
      goTop(){
        $('.scroll-box').animate({scrollTop:'0px'},'slow');
      },
      jump(name){
          if(this.listData2.length > 0){
            this.$router.push('/wdtdChild?username=' + name);
          }
      },
      invite(){
          this.$router.push('/share');
      },
      copy(e){
          let code = this.code;
          this.$copyText(code, this.$t('chongbi.fzcg'));
          this.$toast.center(this.$t('chongbi.fzcg'));
      },
      goBack(){
          this.$router.go(-1)
      }
    },
    filters: {
        times: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D;
        }
        // times: function(timestamp){
        //     var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        //     var Y = date.getFullYear() + '-';
        //     var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        //     var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        //     var h = date.getHours() + ':';
        //     var m = date.getMinutes() + ':';
        //     var s = date.getSeconds();
        //     return Y + M + D;
        // }
    },
    components:{
        noData,
        VueBetterScroll
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        /* background: #0E1530; */
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .head .invite{
        position: absolute;
        right: .3rem;
        top: 0;
        color: #fff;
        font-size: .45rem;
    }
    .cont-box{
        position: absolute;
        left: .24rem;
        right: .24rem;
        top: 1.2rem;
        bottom: 0;
        width: auto;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        /* background: #0E1530;  */
        box-sizing: border-box;
        overflow: hidden;
    }
    .team-box{
        padding: .34rem 0 .16rem;
        background: url('./../assets/wdtd-bg.png') no-repeat right center;
        background-size: 100% 100%;
        box-sizing: border-box;
        text-align: center;
    }
    .team-box .num{
        color: #fff;
        font-size: .84rem;
    }
    .team-box .tips{
        padding: .22rem 0 .32rem;
        color: #eee;
        font-size: .36rem;
    }
    .team-box .copy-box{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 3.2rem;
        height: .66rem;
        margin: auto;
        color: #1F84AE;
        font-size: .48rem;
        border-radius: .25rem;
        background: #fff;
    }
    .team-box .copy-box .icon{
        padding-left: .16rem;
        width: .45rem;
        height: .45rem;
    }
    .title{
        padding: .36rem 0;
        color: #fff;
        font-size: .45rem;
    }
    /* .list-bg{
        position: absolute;
        left: .18rem;
        right: .18rem;
        bottom: 0;
        height: 7rem;
        overflow: hidden;
    } */
    .ul-box .list{
        position: relative;
        margin-bottom: .22rem;
        padding: .3rem .2rem;
        /* background: #040925; */
        background: rgb(4, 9 ,37,.5);
        border-radius: .1rem;
    }
    .ul-box .list .list-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .ul-box .list .list-item .text{
        color: #c4c4c4;
        font-size: .36rem;
    }
    .ul-box .list .list-item .cont{
        color: #fff;
        font-size: .36rem;
    }
    .ul-box .list .list-item-foot{
        padding-top: .26rem;
    }
    .ul-box .list .arrow{
        position: absolute;
        right: 0;
        top: 50%;
        width: .2rem;
        height: .42rem;
        margin-top: -.2rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/wdtd.vue